import $ from 'jquery';
import { setCookie, getCookie } from 'utils/cookies';

const notification = () => {
    const cookieName = 'hide-notification';
    const $notification = $('.s-notification');
    const $closeBtn = $notification.find('.close-icon');
    const cookie = getCookie(cookieName);

    if ($notification.length === 0) return;

    if (cookie === '') {
        $notification.removeClass('hide');
    } else {
        $notification.addClass('hide');
    }

    $closeBtn.click(() => {
        $notification.addClass('hide');
        setCookie(cookieName, 1, 1);
    });
};

$(() => {
    notification();
});
